import * as React from 'react';
import { TLoader } from './Loader.types';
import './Loader.styled.scss';
import { CircularProgress, Skeleton } from '@mui/material';

export const Loader: TLoader = ({ skeleton = false, sx = {} }) => {
  if (skeleton) {
    return <Skeleton variant="text" width={'100%'} height={16} sx={sx} />;
  }
  return (
    <div className="loader">
      <CircularProgress />
    </div>
  );
};
